// One piece of the plan's furniture — kitchen, bar, entrance, wall… — drawn from a
// `floor_features` row (backend/floorplan.py). Position and size are percent of the plan,
// so the same layout reads correctly on the till and in the back office.

export const FEATURE_KINDS = [
  { kind: 'kitchen', label: 'Kitchen' },
  { kind: 'bar', label: 'Bar' },
  { kind: 'entrance', label: 'Entrance' },
  { kind: 'host_stand', label: 'Host stand' },
  { kind: 'toilets', label: 'Toilets' },
  { kind: 'wall', label: 'Wall' },
  { kind: 'till', label: 'Till' },
  { kind: 'label', label: 'Label' },
];

// Every class literal so Tailwind keeps it. Solid blocks for rooms and counters, a dashed
// outline for openings, a hairline for walls, nothing but text for a label.
const STYLE = {
  kitchen:    { box: 'bg-hairline rounded-lg', text: 'text-ink-soft text-sm font-medium uppercase tracking-wide' },
  bar:        { box: 'bg-hairline rounded-lg', text: 'text-ink-soft text-sm font-medium uppercase tracking-wide' },
  toilets:    { box: 'bg-paper rounded-lg border border-hairline', text: 'text-ink-faint text-xs font-medium uppercase tracking-wide' },
  till:       { box: 'bg-paper rounded-md border border-ink-faint', text: 'text-ink-soft text-[11px] font-medium uppercase tracking-wide' },
  host_stand: { box: 'bg-verlo/5 rounded-md border border-verlo/20', text: 'text-verlo text-[11px] font-medium uppercase tracking-wide' },
  entrance:   { box: 'rounded border-2 border-dashed border-ink-faint', text: 'text-ink-faint text-xs uppercase tracking-wide' },
  wall:       { box: 'bg-ink-faint rounded-sm', text: 'hidden' },
  label:      { box: '', text: 'text-ink-faint text-xs font-medium uppercase tracking-wide' },
};

export const featureStyle = (kind) => STYLE[kind] || STYLE.label;

export const FloorFeature = ({ feature, children, className = '', ...rest }) => {
  const s = featureStyle(feature.kind);
  return (
    <div
      className={`absolute flex items-center justify-center ${s.box} ${className}`}
      style={{
        left: `${feature.x}%`, top: `${feature.y}%`, width: `${feature.w}%`, height: `${feature.h}%`,
        // A label is text on the room, not furniture: it sits above the tables (which are
        // z 20–30) so "Steps down" is never hidden under T5. Everything else stays under.
        zIndex: feature.kind === 'label' ? 40 : 1 + (feature.z || 0),
        pointerEvents: feature.kind === 'label' && !rest.onPointerDown ? 'none' : undefined,
      }}
      data-testid={`floor-feature-${feature.kind}`}
      {...rest}
    >
      <span
        className={`${s.text} select-none whitespace-nowrap`}
        style={feature.rotation === 90 ? { transform: 'rotate(90deg)' } : undefined}
      >
        {feature.label}
      </span>
      {children}
    </div>
  );
};

export default FloorFeature;
